import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const BillToPayPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/financial/billToPay/releaseBillToPay`);
    }
  }, [match]);

  return null;
};

export default BillToPayPage;
